import { Star, BadgeCheck } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { TESTIMONIALS } from "../lib/data";

export const Testimonials = () => (
  <section id="avis" data-testid="testimonials-section" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <Reveal className="text-center max-w-2xl mx-auto">
        <Overline>Avis clients</Overline>
        <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
          Ils nous confient leurs vitres
        </h2>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08} className="h-full">
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="h-full rounded-3xl border border-slate-100 bg-slate-50/60 p-7 flex flex-col transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-sky-900/10 hover:bg-white"
            >
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star
                    key={s}
                    size={15}
                    className={s < t.stars ? "fill-amber-400 text-amber-400" : "text-slate-300"}
                  />
                ))}
              </div>
              <blockquote className="mt-4 text-sm text-slate-600 leading-relaxed flex-1">
                « {t.text} »
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-slate-100">
                <p className="text-sm font-bold text-slate-900 flex items-center gap-1.5">
                  {t.name}
                  <BadgeCheck size={14} className="text-sky-600" />
                </p>
                <p className="text-xs text-slate-500 mt-0.5">{t.city} — Avis vérifié</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
